import styles from '@/styles/Bouncing.module.css'

import Picture from '../picture'

interface Props {
  image: string
  imageAlt: string
}

const BouncingImage = ({ image, imageAlt }: Props) => (
  <div className={styles.bouncingImage}>
    <Picture image={image} imageAlt={imageAlt} hasPng />
  </div>
)

export default BouncingImage
